import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { RawUser } from "../../../../../domain/user";
import { Tenant } from "../../../../../domain/tenant";
import moment from "moment";
import { NgForm } from "@angular/forms";
import { TenantRepository } from "../../../../../domain/tenant-repository";
import { EditUserViewModel } from "../../../ViewModels/EditUserViewModel";

@Component({
  selector: "evrideo-user-personal-info",
  templateUrl: "./user-personal-info.component.html",
  styleUrls: ["./user-personal-info.component.scss"],
})
export class UserPersonalInfoComponent implements OnInit {
  @Input()
  userVM: EditUserViewModel;

  @ViewChild("userForm", { static: true }) form: NgForm;

  constructor() {}

  ngOnInit() {
    this.userVM.setPersonalDetailsForm(this.form);
  }
}
